import PropTypes from 'prop-types'
import React from 'react'
import ClassNamesService from '../../../services/ClassNamesService'

const NumberHead = ({ children, className = null }) => (
  <div className={ClassNamesService.execute(['head-cell head-cell--is-number', className])}>{children}</div>
)

NumberHead.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, () => null]),
}

export default NumberHead
